/**
 * Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
 *
 *  Manual Location Checkin
 */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useStores } from 'stores/RootStore';
import { firebase } from 'containers/services/Firebase';
import moment from 'moment';
import { DateTimePicker } from '@material-ui/pickers';

// Design System
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextFieldWithValidation from 'components/InputFields/TextFieldWithValidation';
import CircularProgress from '@material-ui/core/CircularProgress';

function AddCheckin(props) {
  const { open } = props;
  const classes = styles();
  const stores = useStores();
  const [isSaving, setIsSaving] = React.useState(false);
  const [checkInDate, setCheckInDate] = React.useState(moment());

  const handleClose = e => {
    if (props.handleClose) {
      props.handleClose(e);
    }
  };

  const onSubmit = e => {
    e.preventDefault();
    setIsSaving(true);

    const data = {
      companyId: stores.companyStore.company.id,
      companyName: stores.companyStore.company.name,
      locationId: stores.locationStore.location.id,
      locationName: stores.locationStore.location.name,
      vendorCompany: document.getElementById('company').value,
      vendorFirstName: document.getElementById('firstName').value,
      vendorLastName: document.getElementById('lastName').value,
      displayName: document.getElementById('firstName').value + ' ' + document.getElementById('lastName').value,
      formattedDate: moment(checkInDate)
        .utc()
        .format('MM/DD/YYYY'),
      formattedTime: moment(checkInDate)
        .utc()
        .format('HH:MM:ss'),
      checkinDateTime: moment(checkInDate)
        .utc()
        .format(),
      timeInTicks: moment(checkInDate)
        .utc()
        .format('x'),
      manualCheckIn: true,
      manualCheckInByUID: stores.authStore.currentUser.uid,
      manualCheckInBy: stores.authStore.currentUser.displayName,
    };

    firebase
      .addCheckInLog(data)
      .then(() => {
        // Success
        stores.locationStore.fetchBadgeHistory(stores.locationStore.location.id);
        setIsSaving(false);
        // Database updated successfully
        stores.portalStore.snackbar.showSnackbarWithVariantWithDuration('CheckIn added successfully.', 'success', 2750);
        handleClose();
      })
      .catch(error => {
        //Error
        setIsSaving(false);
        handleClose();
      });

    setTimeout(() => {
      setIsSaving(false);
    }, 1400);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='Manual CheckIn'
      className={classes.dialogRoot}
      PaperProps={{
        className: classes.dialogPaper,
      }}
    >
      <form id='checkInForm' autoComplete='off' action='' onSubmit={onSubmit}>
        <DialogTitle id='form-dialog-title'>Manual CheckIn</DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <TextFieldWithValidation
            id='company'
            name='Company'
            label='Company Name'
            type='text'
            visible
            required
            fullWidth
            margin='dense'
            message='Company is a required field.'
            InputLabelProps={{
              className: classes.inputLabel,
            }}
          />
          <TextFieldWithValidation
            id='firstName'
            name='First Name'
            label='First Name'
            type='text'
            visible
            required
            fullWidth
            margin='dense'
            message='First Name is a required field.'
            InputLabelProps={{
              className: classes.inputLabel,
            }}
          />
          <TextFieldWithValidation
            id='lastName'
            name='Last Name'
            label='Last Name'
            type='text'
            visible
            required
            fullWidth
            margin='dense'
            message='Last Name is a required field.'
            InputLabelProps={{
              className: classes.inputLabel,
            }}
          />
          <DateTimePicker
            value={checkInDate}
            onChange={setCheckInDate}
            fullWidth
            required
            margin='dense'
            label='Check-In Date'
          />
          <div className={classes.requiredFields}>*Required Fields</div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color='primary'>
            Cancel
          </Button>
          <Button disabled={isSaving} color='primary' type='submit'>
            Add CheckIn
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

AddCheckin.propTypes = {
  handleClose: PropTypes.func.isRequired,
};

const styles = makeStyles(theme => ({
  root: {},
  addButton: {
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  dialogRoot: {},
  dialogPaper: {
    minWidth: '450px',
    [theme.breakpoints.down('xs')]: {
      minWidth: '300px',
    },
  },
  dialogContent: {},
  dialogTitle: {
    margin: 0,
    padding: theme.spacing(2),
  },
  dialogFooter: {
    justifyContent: 'center',
    padding: '15px',
  },
  requiredFields: {
    fontSize: '10pt',
    color: theme.palette.error.main,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
  submitButton: {},
  inputLabel: {
    fontSize: '11pt',
    [theme.breakpoints.down('xs')]: {
      fontSize: '10pt',
    },
  },
  buttonProgress: {
    zIndex: 1,
    position: 'absolute',
    marginLeft: -1,
  },
  tableProgress: {
    zIndex: 999,
    position: 'absolute',
    left: '50%',
    marginTop: 125,
    marginLeft: -15,
  },
}));

export default AddCheckin;
